import type {
  RecareKpiData,
  RecareOverviewResult,
} from '@services/api/dashboard/recare.api'
import type { DashboardMetricItemData } from '../types/dashboardMetrics.types'
import type { HalfDonutConfig } from '@components/pages/Dashboard/Overview/dashboardOverview.mockData'
import { parseRecareRatePercent } from '@pages/Dashboard/RecareDetail/recareDetail.mockData'

export function mapRecareOverviewToTopMetrics(
  kpis: RecareKpiData,
): DashboardMetricItemData[] {
  return [
    {
      id: 'patients-due',
      leftLabel: 'Patients due',
      value: kpis.patientsDue,
    },
    {
      id: 'scheduled-recare',
      leftLabel: 'Scheduled',
      value: kpis.scheduled,
    },
    {
      id: 'overdue-recare',
      leftLabel: 'Overdue',
      value: kpis.overdue,
    },
  ]
}

export function buildRecareDonutFromOverview(
  overview: RecareOverviewResult | null | undefined,
): HalfDonutConfig | null {
  if (!overview?.kpis) return null
  const rate = parseRecareRatePercent(overview.kpis.recareRate)
  const remainder = Math.max(0, 100 - rate)
  return {
    primaryValue: rate,
    secondaryValue: 100,
    slices: [
      { name: 'Recare rate', value: rate, color: 'var(--blue-400)' },
      { name: 'Remaining', value: remainder, color: 'var(--gray-200)' },
    ],
    valueFormatter: (val: number): string => `${Math.round(val)}%`,
  }
}

export function getRecareRateGoalLabel(
  overview: RecareOverviewResult | null | undefined,
): string {
  const pct = overview?.goals?.recareRateGoalPct ?? 90
  return `${pct}%`
}
